<template lang="pug">
v-form
  v-row
    v-col( :md="!isCustomer ? 2 : 4" )
      DatePicker( v-model="dateStart" label="Дата начала" )
    v-col( :md="!isCustomer ? 2 : 4" )
      DatePicker( v-model="dateEnd" label="Дата окончания" )
    v-col( :md="!isCustomer ? 2 : 4" )
      v-select( v-model="project" item-text="name" item-value="id" :items="projects" label="Проект" )
    v-col( :md="!isCustomer ? 2 : 4" )
      v-autocomplete( v-model="city" v-if="!isCustomer" label="Город" multiple chips :items="cities" )
    v-col( :md="!isCustomer ? 2 : 4" )
      v-autocomplete( v-if="!isCustomer" v-model="user" :items="users" label="Пользователи" chips item-text="name" item-value="id" )
  v-row
    v-col
      v-btn( :disabled="!valid" @click="load") Найти
      v-btn.ml-2( :disabled="!valid" @click="loadAllReport") Скачать все

  v-dialog(v-model="loadingDialog" width="unset" :persistent="loadingAll")
      v-card
        v-card-title Загрузка...
        v-card-text(v-if="loadingAll")
          v-progress-linear(color="deep-purple accent-4" indeterminate rounded height="6")
  v-row
    v-col
      v-data-table( class="elevation-1" :headers="headers" :items="reports" :loading="loading" loading-text="Загружается... Пожалуйста подождите" )
        template( v-slot:item.name="{ item }" )
          router-link( :to="{ name: 'downloaditem', params: { project: project, id: item.id, start: dateStart, end: dateEnd, cities: city.join(), user: user } }" ) {{ item.name }}
        template( v-slot:item.count="{ item }" ) {{ item.points }} / {{ item.reports }}
        template( v-slot:item.action="{ item }" )
          Export( v-if="item.reports > 0" small :zip="getZip(item.id)" )

</template>


<script>
import { projectService, networkService, reportService, tradepointService } from '@/_services'
import { mapMutations, mapState, mapGetters } from "vuex";
import Export from './Export'
import DatePicker from './DatePicker';

export default {
  components: {
    Export,
    DatePicker
  },

  data: () => ({
    dateStart: new Date().toISOString().substr(0, 10),
    dateEnd: new Date().toISOString().substr(0, 10),
    modal: false,
    project: 0,
    city: [],
    headers: [
      { text: 'Название сети', value: 'name' },
      { text: 'Кол-во точек / Кол-во отчётов', value: 'count' },
      { text: 'Действия', value: 'action' }
    ],
    reports: [],
    loading: false,
    cities: [],
    user: 0,
    loadingDialog: false,
    loadingAll: false,
  }),

  mounted() {
    this.loadProjects()
  },

  
  watch: {
    project: function(val) {
      this.loadCities()
    },
  },

  computed: {
    ...mapState("project", ["projects"]),
    ...mapGetters("authentication", ["checkRole"]),
    ...mapGetters("user", ["users"]),

    isCustomer() {
      return this.checkRole(0)
    },

    valid() {
      return this.project != 0
    },
  },

  methods: {
    ...mapMutations("project", ["setProjects"]),

    loadProjects() {
      if (this.projects.length > 0) return
      projectService.list().then(data => {
        this.setProjects(data)
        if (data.length > 0)
          this.project = data[0].id
      })
    },

    load() {
      this.loading = true
      if(this.user == undefined) this.user = 0
      networkService.loadForReport(this.project, this.dateStart, this.dateEnd, this.city.join(), this.user).then(data => {
        this.reports = data;
      }).finally(() => this.loading = false)
    },

    loadAllReport() {
      this.loadingDialog = true
      this.loadingAll = true
      let params = {
          project_id: this.project,
          start: this.dateStart,
          end: this.dateEnd,
          cities: this.city.join(),
          userId: this.user
        }
      reportService.loadAllExcel(params).then(response => {
        let filename = this.projects.find(el => el.id == this.project).name + ".zip";
        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
        this.loadingDialog = false
        this.loadingAll = false
      }).catch(err => {
        console.error('Ошибка при скачивании файла', err);
      });
    },

    loadCities() {
      tradepointService.loadCities(this.project, []).then(data => this.cities = data)
    },

    loadAddresses() {
      tradepointService.loadAddresses(this.project, []).then(data => this.addresses = data)
    },

    getZip(id) {
      return {
        method: reportService.excelByNetworkLink,
        id: id,
        params: {
          project_id: this.project,
          start: this.dateStart,
          end: this.dateEnd,
          cities: this.city.join(),
          userId: this.user
        }
      }
    }
  }
}
</script>